import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { TextField, MenuItem, Radio } from "@material-ui/core";
import { isMobile, isTablet } from 'react-device-detect';
import Autocomplete from "@material-ui/lab/Autocomplete";
import * as FontAwesome from '@fortawesome/react-fontawesome';
import { faEdit, faSave } from '@fortawesome/free-regular-svg-icons';
import { withSnackbar } from 'notistack';
import { DatePicker, InputCpf, InputRG, InputCep, InputTelefone } from "components";
import api from "services/structure/api";
import { startLoadingAnimate, stopLoadingAnimate } from "services/ducks/loading";
import { SessionTitle, ContainerTitle, ButtonContainer, FullSizedButton } from '../styles';
import { removeAccents, findMostSimilar, similarity } from 'services/structure/textUtils';
import apiLogin from "services/structure/apiLogin";
import { updateUserData } from "services/ducks/auth";

class MeusDados extends Component {

  constructor(props) {
    super(props);
    this.state = this.createStateFromRedux();
    this.fillMenuOptions();
  }

  componentDidUpdate(prevProps){
    if (this.state.id !== prevProps.authData.usuario.pessoa.id) {
      const state = this.createStateFromRedux();
      this.setState(state);
      this.fillMenuOptions();
    }
  }
  
  createStateFromRedux() {
    const tipoPpeRaw = Number(this.props.authData.usuario.pessoa.tipoPessoaPoliticamenteExposta);
    const politicamenteExposta = tipoPpeRaw === 2 || tipoPpeRaw === 3 ? tipoPpeRaw : 1;
    return {
      disabled: true,
      id: this.props.authData.usuario.pessoa.id,
      // Dados cadastrais
      dataNascimento: this.dateConstructorFromTimestamp(this.props.authData.usuario.pessoa.dataNascimento),
      sexo: this.props.authData.usuario.pessoa.sexo ?? "",
      estadoCivil: this.props.authData.usuario.pessoa.estadoCivil ?? "",
      nomeMae: this.props.authData.usuario.pessoa.nomeMae ?? "",
      nomePai: this.props.authData.usuario.pessoa.nomePai ?? "",
      // Dados de identificacao
      cpf: this.props.authData.usuario.pessoa.cpf ?? "",
      numeroRG: this.props.authData.usuario.pessoa.numeroRG ?? "",
      orgaoExpedidorRG: this.props.authData.usuario.pessoa.orgaoExpedidorRG ?? "",
      dtExpedicaoRG: this.dateConstructorFromTimestamp(this.props.authData.usuario.pessoa.dtExpedicaoRG),
      nacionalidade: this.props.authData.usuario.pessoa.nacionalidade ?? 0,
      nacionalidadeNome: this.props.authData.usuario.pessoa.nomeNacionalidade ?? "",
      naturalidade: "",
      estadoNascimento: this.props.authData.usuario.pessoa.estadoNascimento ?? "",
      politicamenteExposta,
      cargoPpe: politicamenteExposta === 2
        ? (this.props.authData.usuario.pessoa.cargoPpe ?? "")
        : "",
      dtDesdePpe: politicamenteExposta === 2
        ? this.dateConstructorFromTimestamp(this.props.authData.usuario.pessoa.dtDesdePpe)
        : null,
      dtInicioPpe: politicamenteExposta === 2
        ? this.dateConstructorFromTimestamp(this.props.authData.usuario.pessoa.dtInicioPpe)
        : null,
      dtFimPpe: politicamenteExposta === 2
        ? this.dateConstructorFromTimestamp(this.props.authData.usuario.pessoa.dtFimPpe)
        : null,
      idGrauRelacionamentoPpe: politicamenteExposta === 3
        ? (this.props.authData.usuario.pessoa.idGrauRelacionamentoPpe ?? "")
        : "",
      tbxCargoFamiliarPpe: politicamenteExposta === 3
        ? (this.props.authData.usuario.pessoa.cargoPpe ?? "")
        : "",
      dtDesdeFamiliarPpe: politicamenteExposta === 3
        ? this.dateConstructorFromTimestamp(this.props.authData.usuario.pessoa.dtDesdePpe)
        : null,
      dtFamiliarInicioPpe: politicamenteExposta === 3
        ? this.dateConstructorFromTimestamp(this.props.authData.usuario.pessoa.dtInicioPpe)
        : null,
      dtFamiliarFimPpe: politicamenteExposta === 3
        ? this.dateConstructorFromTimestamp(this.props.authData.usuario.pessoa.dtFimPpe)
        : null,
      tiposDependenciaPpe: [],
      // Dados de contato
      foundCepDadosContato: false,
      cepDadosContato: this.props.authData.usuario.pessoa.cepDadosContato ?? "",
      logradouroDadosContato: this.props.authData.usuario.pessoa.logradouroDadosContato ?? "",
      complementoDadosContato: this.props.authData.usuario.pessoa.complementoDadosContato ?? "",
      bairroDadosContato: this.props.authData.usuario.pessoa.bairroDadosContato ?? "",
      cidadeDadosContato: this.props.authData.usuario.pessoa.cidadeDadosContato ?? "",
      idCidadeDadosContato: this.props.authData.usuario.pessoa.idCidadeDadosContato ?? "",
      estadoDadosContato: this.props.authData.usuario.pessoa.estatoDadosContato ?? "",
      telefoneDadosContato: this.props.authData.usuario.pessoa.telefoneDadosContato ?? "",
      telefoneMovelDadosContato: this.props.authData.usuario.pessoa.telefoneMovelDadosContato ?? "",
      emailDadosContato: this.props.authData.usuario.pessoa.emailDadosContato ?? "",
      // Representante legal, tutor ou curador
      foundCepRepresentante: false,
      nomeRepresentante: this.props.authData.usuario.pessoa.nomeRepresentante ?? "",
      cpfRepresentante: this.props.authData.usuario.pessoa.cpfRepresentante ?? "",
      dtNascimentoRepresentante: this.dateConstructorFromTimestamp(this.props.authData.usuario.pessoa.dtNascimentoRepresentante),
      parentescoRepresentante: this.props.authData.usuario.pessoa.parentescoRepresentante ?? "",
      cepRepresentante: this.props.authData.usuario.pessoa.cepRepresentante ?? "",
      idTipoDependenciaRep: this.props.authData.usuario.pessoa.idTipoDependenciaRep ?? 0,
      logradouroRepresentante: this.props.authData.usuario.pessoa.logradouroRepresentante ?? "",
      complementoRepresentante: this.props.authData.usuario.pessoa.complementoRepresentante ?? "",
      bairroRepresentante: this.props.authData.usuario.pessoa.bairroRepresentante ?? "",
      cidadeRepresentante: this.props.authData.usuario.pessoa.cidadeRepresentante ?? "",
      estadoRepresentante: this.props.authData.usuario.pessoa.estadoRepresentante ?? "",
      telefoneRepresentante: this.props.authData.usuario.pessoa.telefoneRepresentante ?? "",
      telefoneMovelRepresentante: this.props.authData.usuario.pessoa.telefoneMovelRepresentante ?? "",
      emailRepresentante: this.props.authData.usuario.pessoa.emailRepresentante ?? "",
      // Collections
      estadosCivis: [],
      estados: [],
      cidadesDadosContato: [],
      cidadesRepresentante: [],
      algumCampoEditado: false
    }

  }

  fillMenuOptions () {

    this.props.startLoadingAnimate();
    // Inicializadores

    let promises = [];

    let tiposDependenciaPpePromise = api.get("/beneficiario/tipo-dependencia")
      .then(response => ({ tiposDependenciaPpe: response.data }))
      .catch(err => console.error(err));
    promises.push(tiposDependenciaPpePromise);

    let estadosCivisPromise = api.get("/estadoCivil")
      .then(response => ({ estadosCivis: response.data }))
      .catch(err => console.error(err));
    promises.push(estadosCivisPromise);

    let localidadeEstadosPromise = api.get("/localidade/estados")
      .then(response => ({ estados: response.data }))
      .catch(err => console.error(err));
      promises.push(localidadeEstadosPromise);
      
    let naturalidadeId = this.props.authData.usuario.pessoa.naturalidade;
    if (naturalidadeId) {

      let naturalidadePromise = api.get("/localidade/cidades/"+naturalidadeId)
      .then(response => ({ 
        naturalidadeObj: response.data,
        naturalidade: response.data.municipio,
      }))
      .catch(err => console.error(err));
      promises.push(naturalidadePromise);

    }

    let cidadeDadosContatoId = this.props.authData.usuario.pessoa.idCidadeDadosContato;
    if (cidadeDadosContatoId) {

      let cidadeDadosContato = api.get("/localidade/cidades/"+cidadeDadosContatoId)
      .then(response => ({ 
        cidadeDadosContatoObj: response.data,
        cidadeDadosContato: response.data.municipio,
      }))
      .catch(err => console.error(err));
      promises.push(cidadeDadosContato);

    }
    
    let cidadeRepresentanteId = this.props.authData.usuario.pessoa.idCidadeRepresentante;
    if (cidadeRepresentanteId) {

      let cidadeRepresentante = api.get("/localidade/cidades/"+cidadeRepresentanteId)
      .then(response => ({ 
        cidadeRepresentanteObj: response.data,
        cidadeRepresentante: response.data.municipio,
      }))
      .catch(err => console.error(err));
      promises.push(cidadeRepresentante);

    }

    Promise.all(promises)
      .then( values => { 
        let newState = Object.assign(...values)
        if (newState.naturalidadeObj) {
          let naturalidade = newState.naturalidadeObj;
          if (naturalidade) {
            let estadoNascimento = newState.estados.find(estado => estado.sigla === naturalidade.siglaEstado);
            newState.estadoNascimento = estadoNascimento?.estado;
          }
        }

        let cidadeDadosContato = newState.cidadeDadosContatoObj;
        if (cidadeDadosContato) {
          let estadoDadosContato = newState.estados.find(estado => estado.sigla === cidadeDadosContato.siglaEstado);
          newState.estadoDadosContato = estadoDadosContato?.estado;
          this.loadCidadesPorEstado(estadoDadosContato.id).then(response => {
            this.setState({ cidadesDadosContato: response.data, foundCepDadosContato: false })
          })
        }

        let cidadeRepresentante = newState.cidadeRepresentanteObj;
        if (cidadeRepresentante) {
          let estadoRepresentante = newState.estados.find(estado => estado.sigla === cidadeRepresentante.siglaEstado);
          newState.estadoRepresentante = estadoRepresentante?.estado;
          this.loadCidadesPorEstado(estadoRepresentante.id).then(response => {
            this.setState({ cidadesRepresentante: response.data, foundCepRepresentante: false })
          })
        }

        this.setState(newState)
        this.props.stopLoadingAnimate();
      })
      .catch((e) => {
        const mensagem = "Não foi possível conectar-se ao servidor. Recarregue a página! " ;
        this.props.enqueueSnackbar(mensagem, { variant: 'error' });
        this.props.stopLoadingAnimate();
      });
  }

  state = {}

  dateConstructorFromTimestamp = timestamp => {
    if (!timestamp) {
      return null;
    }
    if (typeof timestamp === "string" && /^\d{4}-\d{2}-\d{2}$/.test(timestamp)) {
      const [year, month, day] = timestamp.split("-").map(Number);
      return new Date(year, month - 1, day);
    }
    return new Date(timestamp);
  }

  formatDateOnly = value => {
    if (!value) {
      return null;
    }
    const d = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(d.getTime())) {
      return null;
    }
    const yyyy = String(d.getUTCFullYear()).padStart(4, "0");
    const mm = String(d.getUTCMonth() + 1).padStart(2, "0");
    const dd = String(d.getUTCDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  }

  setStateOnValueChange = (key, value) => {
    const newState = { [key]: value, algumCampoEditado: true };
    this.setState(newState);
  }

  changePoliticamenteExposta = (next) => {
    const patch = { politicamenteExposta: next, algumCampoEditado: true };
    if (next !== 2) {
      patch.cargoPpe = "";
      patch.dtDesdePpe = null;
      patch.dtInicioPpe = null;
      patch.dtFimPpe = null;
    }
    if (next !== 3) {
      patch.idGrauRelacionamentoPpe = "";
      patch.tbxCargoFamiliarPpe = "";
      patch.dtDesdeFamiliarPpe = null;
      patch.dtFamiliarInicioPpe = null;
      patch.dtFamiliarFimPpe = null;
    }
    this.setState(patch);
  }

  validateDateRange = (startDate, endDate, endFieldName) => {
    if (startDate && endDate && new Date(endDate) < new Date(startDate)) {
      this.props.enqueueSnackbar('Data Fim deve ser posterior a data de início', { variant: 'warning' });
      this.setStateOnValueChange(endFieldName, null);
    }
  }

  isCalendarAfterToday = (value) => {
    if (!value) {
      return false;
    }
    const d = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(d.getTime())) {
      return false;
    }
    const t = new Date();
    if (d.getFullYear() !== t.getFullYear()) {
      return d.getFullYear() > t.getFullYear();
    }
    if (d.getMonth() !== t.getMonth()) {
      return d.getMonth() > t.getMonth();
    }
    return d.getDate() > t.getDate();
  }

  validatePpeOpcao2 = () => {
    const { cargoPpe, dtDesdePpe, dtInicioPpe, dtFimPpe } = this.state;
    if (!String(cargoPpe ?? "").trim()) {
      this.props.enqueueSnackbar("O campo 'Cargo/Função' é obrigatório em Pessoa Politicamente Exposta.", { variant: 'warning' });
      return false;
    }
    const hasDesde = !!dtDesdePpe;
    const hasInicio = !!dtInicioPpe;
    const hasFim = !!dtFimPpe;
    const periodoCompleto = hasInicio && hasFim;
    const msgXor = "Deve ser informado em Pessoa Politicamente Exposta a data 'Desde' ou no 'período', porém não ambos.";
    if (hasDesde && (hasInicio || hasFim)) {
      this.props.enqueueSnackbar(msgXor, { variant: 'warning' });
      return false;
    }
    if (!hasDesde && !periodoCompleto) {
      this.props.enqueueSnackbar(msgXor, { variant: 'warning' });
      return false;
    }
    if (periodoCompleto && new Date(dtFimPpe) < new Date(dtInicioPpe)) {
      this.props.enqueueSnackbar('Data Fim deve ser posterior a data de início', { variant: 'warning' });
      return false;
    }
    if (hasDesde && this.isCalendarAfterToday(dtDesdePpe)) {
      this.props.enqueueSnackbar("O campo 'Desde' informado em Pessoa Politicamente Exposta não pode ser superior à data atual.", { variant: 'warning' });
      return false;
    }
    if (periodoCompleto && this.isCalendarAfterToday(dtFimPpe)) {
      this.props.enqueueSnackbar("O campo 'Data Fim' informado em Pessoa Politicamente Exposta não pode ser superior à data atual.", { variant: 'warning' });
      return false;
    }
    return true;
  }

  validatePpeOpcao3 = () => {
    const { idGrauRelacionamentoPpe, tbxCargoFamiliarPpe, dtDesdeFamiliarPpe, dtFamiliarInicioPpe, dtFamiliarFimPpe } = this.state;
    if (!String(idGrauRelacionamentoPpe ?? "").trim()) {
      this.props.enqueueSnackbar("O campo 'Grau' é obrigatório em Pessoa Politicamente Exposta.", { variant: 'warning' });
      return false;
    }
    if (!String(tbxCargoFamiliarPpe ?? "").trim()) {
      this.props.enqueueSnackbar("O campo 'Cargo/Função' é obrigatório em Pessoa Politicamente Exposta.", { variant: 'warning' });
      return false;
    }
    const hasDesde = !!dtDesdeFamiliarPpe;
    const hasInicio = !!dtFamiliarInicioPpe;
    const hasFim = !!dtFamiliarFimPpe;
    const periodoCompleto = hasInicio && hasFim;
    const msgXor = "Deve ser informado em Pessoa Politicamente Exposta a data 'Desde' ou no 'período', porém não ambos.";
    if (hasDesde && (hasInicio || hasFim)) {
      this.props.enqueueSnackbar(msgXor, { variant: 'warning' });
      return false;
    }
    if (!hasDesde && !periodoCompleto) {
      this.props.enqueueSnackbar(msgXor, { variant: 'warning' });
      return false;
    }
    if (periodoCompleto && new Date(dtFamiliarFimPpe) < new Date(dtFamiliarInicioPpe)) {
      this.props.enqueueSnackbar('Data Fim deve ser posterior a data de início', { variant: 'warning' });
      return false;
    }
    if (hasDesde && this.isCalendarAfterToday(dtDesdeFamiliarPpe)) {
      this.props.enqueueSnackbar("O campo 'Desde' informado em Pessoa Politicamente Exposta não pode ser superior à data atual.", { variant: 'warning' });
      return false;
    }
    if (periodoCompleto && this.isCalendarAfterToday(dtFamiliarFimPpe)) {
      this.props.enqueueSnackbar("O campo 'Data Fim' informado em Pessoa Politicamente Exposta não pode ser superior à data atual.", { variant: 'warning' });
      return false;
    }
    return true;
  }
  
  handleSave = e => {
    this.setState({ error : "" });
    e.preventDefault();
    const tipoPpeValidacao = Number(this.state.politicamenteExposta);
    if (tipoPpeValidacao === 2 && !this.validatePpeOpcao2()) {
      return;
    }
    if (tipoPpeValidacao === 3 && !this.validatePpeOpcao3()) {
      return;
    }
    this.props.startLoadingAnimate();
    const { 
      estados, 
      estadosCivis,   
      naturalidadeObj, 
      cidadeDadosContato, 
      cidadeDadosContatoObj, 
      cidadeRepresentante, 
      cidadeRepresentanteObj, 
      tbxCargoFamiliarPpe,
      dtDesdeFamiliarPpe,
      dtFamiliarInicioPpe,
      dtFamiliarFimPpe,
      nacionalidadeNome,
      ...payload 
    } = this.state;
    payload.naturalidade = naturalidadeObj?.id;
    const tipoPpe = Number(payload.politicamenteExposta);
    payload.tipoPessoaPoliticamenteExposta = tipoPpe;
    delete payload.tiposDependenciaPpe;
    if (tipoPpe === 1) {
      payload.dtDesdePpe = null;
      payload.dtInicioPpe = null;
      payload.dtFimPpe = null;
      payload.cargoPpe = null;
      payload.familiarPpe = null;
      payload.idGrauRelacionamentoPpe = null;
    } else if (tipoPpe === 2) {
      payload.familiarPpe = null;
      payload.idGrauRelacionamentoPpe = null;
    } else if (tipoPpe === 3) {
      payload.cargoPpe = tbxCargoFamiliarPpe;
      payload.dtDesdePpe = dtDesdeFamiliarPpe;
      payload.dtInicioPpe = dtFamiliarInicioPpe;
      payload.dtFimPpe = dtFamiliarFimPpe;
    }

    payload.dtDesdePpe = this.formatDateOnly(payload.dtDesdePpe);
    payload.dtInicioPpe = this.formatDateOnly(payload.dtInicioPpe);
    payload.dtFimPpe = this.formatDateOnly(payload.dtFimPpe);

    api.put("/user/my/participante", payload)
      .then( () => {
        this.props.enqueueSnackbar('Dados atualizados com sucesso!', { variant: 'success' });
        // Atualiza os dados no redux
        apiLogin.get("user", { params: { token: this.props.authData.token } })
          .then(response => {
            const { loginsSecundarios, ...newUserDataa } = response.data
            const authData = {
              ...this.props.authData,
              ...newUserDataa
            }
            this.props.updateUserData(authData);
            this.setState({
              disabled: true, 
              algumCampoEditado: false
            });
          })
      }).catch (err => {
        const mensagem = err.response?.data?.mensagem ?? "Não foi possível conectar-se ao servidor. " ;
        this.props.enqueueSnackbar(mensagem, { variant: 'error' });
      }).finally( () => this.props.stopLoadingAnimate() );
  };

  // EnderecoDadosContato
  // TODO: Pensar numa forma de componentizar
  preencherEnderecoDadosContato = endereco => {

    if (endereco.erro) {
      this.setState({
        foundCepDadosContato: false
      });
      return;
    }

    let estado = this.state.estados.find(estado => estado.sigla === endereco?.uf);
    
    this.setState({
      foundCepDadosContato: true,
      logradouroDadosContato: endereco?.logradouro,
      bairroDadosContato: endereco?.bairro,
      estadoDadosContato: estado?.estado,
      cidadeDadosContato: ""
    });

    if (estado) {
      this.loadCidadesPorEstado(estado.id)
        .then( response => this.mapCidadeDadosContato(response, endereco?.localidade?.toLowerCase()) );
    }
  }

  changeEnderecoDadosContato = (key, value) => {
    const newState = { 
      [key]: value,
      foundCepDadosContato: false
    };
    this.setState(newState);
  }

  mapCidadeDadosContato = (response, nomeCidadeViacep) => {
    const cidades = response.data;
    const cidadeToSearch = removeAccents(nomeCidadeViacep);
    const cidade = findMostSimilar (cidades, cidadeToSearch, 0.75, (v, searched) => {
      if (!v || !searched) {
        return 0.0;
      }
      return similarity(v.municipio, cidadeToSearch);
    });
    this.setState({
      cidadeDadosContato: cidade.municipio,
      cidadesDadosContato: cidades
    })
  }

  changeCidadeDadosContatoValue = newValue => {
    this.setState({
      idCidadeDadosContato: newValue.id,
      cidadeDadosContato: newValue.municipio,
      foundCepDadosContato: false,
    });
  }

  changeCepDadosContatoValue = e => {
    this.setState({
      cepDadosContato: e.target.value,
      foundCepDadosContato: false,
    });
  }

  changeEstadoDadosContatoValue = e => {
    const estadoDadosContato = e.target.value;

    this.setStateOnValueChange('estadoDadosContato', estadoDadosContato);

    this.props.startLoadingAnimate();
    const estado = this.state.estados.find(e => e.estado === estadoDadosContato);
    
    this.loadCidadesPorEstado(estado.id).then(response => {
      this.setState({ cidadesDadosContato: response.data, foundCepDadosContato: false, cidadeDadosContato: "" })
    })
    .catch(err => this.props.enqueueSnackbar("Houve um erro ao tentar buscar a lista de cidades. Você está conectado à internet?", { variant: 'error' }))
    .finally( () => this.props.stopLoadingAnimate() );
  }

  // EnderecoRepresentante
  preencherEnderecoRepresentante = endereco => {

    if (endereco.erro) {
      this.setState({
        foundCepRepresentante: false
      });
      return;
    }

    let estado = this.state.estados.find(estado => estado.sigla === endereco?.uf);
    
    this.setState({
      foundCepRepresentante: true,
      logradouroRepresentante: endereco?.logradouro,
      bairroRepresentante: endereco?.bairro,
      estadoRepresentante: estado?.estado,
      cidadeRepresentante: ""
    });

    if (estado) {
      this.loadCidadesPorEstado(estado.id)
        .then( response => this.mapCidadeRepresentante(response, endereco?.localidade?.toLowerCase()) );
    }
  }

  changeEnderecoRepresentante = (key, value) => {
    const newState = { 
      [key]: value,
      foundCepRepresentante: false
    };
    this.setState(newState);
  }

  mapCidadeRepresentante = (response, nomeCidadeViacep) => {
    const cidades = response.data;
    const cidadeToSearch = removeAccents(nomeCidadeViacep);
    const cidade = findMostSimilar (cidades, cidadeToSearch, 0.75, (v, searched) => {
      if (!v || !searched) {
        return 0.0;
      }
      return similarity(v.municipio, cidadeToSearch);
    });
    this.setState({
      cidadeRepresentante: cidade.municipio,
      cidadesRepresentante: cidades
    })
  }

  changeCidadeRepresentanteValue = newValue => {
    this.setState({
      idCidadeRepresentante: newValue.id,
      cidadeRepresentante: newValue.municipio,
      foundCepRepresentante: false,
    });
  }

  changeCepRepresentanteValue = e => {
    this.setState({
      cepRepresentante: e.target.value,
      foundCepRepresentante: false,
    });
  }

  changeEstadoRepresentanteValue = e => {
    const estadoRepresentante = e.target.value;

    this.setStateOnValueChange('estadoRepresentante', estadoRepresentante);

    this.props.startLoadingAnimate();
    const estado = this.state.estados.find(e => e.estado === estadoRepresentante);
    
    this.loadCidadesPorEstado(estado.id).then(response => {
      this.setState({ cidadesRepresentante: response.data, foundCepRepresentante: false, cidadeRepresentante: "" })
    })
    .catch(err => this.props.enqueueSnackbar("Houve um erro ao tentar buscar a lista de cidades. Você está conectado à internet?", { variant: 'error' }))
    .finally( () => this.props.stopLoadingAnimate() );
  }

  loadCidadesPorEstado = idEstado => {
    return api.get("/localidade/estados/" + idEstado + "/cidades")
  }

  changeAutocompleteValue = (event, newValue, stateKey) => {
    if (event && event?.type !== "blur") { 
      this.setStateOnValueChange(stateKey, newValue) }
  }

  render() {
    return (
      <div>
        <ContainerTitle className="title-meus-dados">MEUS DADOS </ContainerTitle>
        {isMobile && <img src={process.env.PUBLIC_URL + '/meus-dados-subtitle.png'} className="meus-dados-subtitle" alt=""/> }
        <ButtonContainer className="top-button-container">
          <Col sm={!isMobile ? 4 : isTablet ? 12 : 6}>
            <FullSizedButton type="submit" className={`app-meus-dados-editar ${this.props.className}`} variant="contained"
              onClick={() => this.setState( { disabled : false } )}>
              <FontAwesome.FontAwesomeIcon icon={faEdit} className={`app-meus-dados-editar-icon ${this.props.className}`}/> 
              <span  className={`app-meus-dados-editar-label ${this.props.className}`}>EDITAR</span>
            </FullSizedButton>
          </Col>
          <Col  sm={!isMobile ? 4 : isTablet ? 12 : 6}>
            <FullSizedButton 
              type="submit" 
              className={`app-meus-dados-editar ${this.props.className}`} 
              variant="contained"
              disabled={this.state.disabled || !this.state.algumCampoEditado}
              onClick={this.handleSave}>
              <FontAwesome.FontAwesomeIcon icon={faSave} className={`app-meus-dados-editar-icon ${this.props.className}`}/> 
              <span  className={`app-meus-dados-editar-label ${this.props.className}`}>SALVAR</span>
            </FullSizedButton>
          </Col>
          <Col sm={4}>
            {!isMobile && <img src={process.env.PUBLIC_URL + '/meus-dados-subtitle.png'} className="meus-dados-subtitle" alt=""/> }
          </Col>
        </ButtonContainer>
        <SessionTitle>DADOS CADASTRAIS</SessionTitle>
        <Row>
            <Col sm={isMobile ? 6 : 4}>
              <DatePicker
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  disabled={true}
                  label="Data de Nascimento"
                  value={this.state.dataNascimento}
                  onChange={ (date) => this.setStateOnValueChange('dataNascimento', date) }
                  name="dataNascimento"/>
            </Col>
            <Col sm={isMobile ? 6 : 4}>
              <TextField 
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  disabled={this.state.disabled}
                  label="Sexo"
                  name="sexo"
                  value={this.state.sexo}
                  onChange={ (e) => this.setStateOnValueChange('sexo', e.target.value) }
                  select={true}>
                <MenuItem value="M">Masculino</MenuItem>
                <MenuItem value="F">Feminino</MenuItem>
              </TextField>
            </Col>
            <Col sm={isMobile ? 6 : 4}>
              <TextField 
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  disabled={this.state.disabled}
                  label="Estado Civil"
                  name="estadoCivil"
                  value={this.state.estadoCivil}
                  onChange={ (e) => this.setStateOnValueChange('estadoCivil', e.target.value) }
                  select={true}>
                  {this.state.estadosCivis.map(function(object, i){
                      return (<MenuItem value={object.descricao}>{object.descricao}</MenuItem>)
                  })}
              </TextField>
            </Col>
            <Col sm={isMobile ? 6 : 6}> 
              <TextField 
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  disabled={true}
                  label="Nome da mãe"
                  value={this.state.nomeMae}
                  onChange={ (e) => this.setStateOnValueChange('nomeMae', e.target.value) }
                  name="nomeMae"
                  inputProps={{ maxLength: 100 }}
                  />
            </Col>
            <Col sm={isMobile ? 6 : 6}> 
              <TextField 
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  disabled={true}
                  label="Nome do pai"
                  value={this.state.nomePai}
                  onChange={ (e) => this.setStateOnValueChange('nomePai', e.target.value) }
                  name="nomePai"
                  inputProps={{ maxLength: 100 }}/>
            </Col>
        </Row>
        <SessionTitle>DADOS DE IDENTIFICAÇÃO</SessionTitle>
        <Row>
            <Col sm={isMobile ? 6 : 3}>
              <InputCpf 
                variant="outlined"
                margin="normal"
                fullWidth
                disabled={true}
                label="CPF"
                value={this.state.cpf}
                onChange={ (e) => this.setStateOnValueChange('cpf', e.target.value) }
                name="cpf"/>
            </Col>
            <Col sm={isMobile ? 6 : 3}>
              <InputRG 
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  disabled={true}
                  label="RG"
                  value={this.state.numeroRG}
                  onChange={ (e) => this.setStateOnValueChange('numeroRG', e.target.value) }
                  name="numeroRG"/>
            </Col>
            <Col sm={isMobile ? 6 : 3}>  
              <TextField 
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  disabled={true}
                  label="Órgão Expedidor"
                  value={this.state.orgaoExpedidorRG}
                  onChange={ (e) => this.setStateOnValueChange('orgaoExpedidorRG', e.target.value) }
                  name="orgaoExpedidorRG"
                  inputProps={{ maxLength: 10 }}/>
            </Col>
            <Col sm={isMobile ? 6 : 3}>  
              <DatePicker
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  disabled={true}
                  label="Data de expedição"
                  value={this.state.dtExpedicaoRG}
                  onChange={ (date) => this.setStateOnValueChange('dtExpedicaoRG', date) }
                  name="dtExpedicaoRG"/>
            </Col>
            <Col sm={isMobile ? 6 : 4}> 
              <TextField 
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  disabled={true}
                  label="Estado do nascimento"
                  value={this.state.estadoNascimento}
                  onChange={ (e) => this.setStateOnValueChange('estadoNascimento', e.target.value) }
                  name="estadoNascimento"
                  inputProps={{ maxLength: 20 }}/>
            </Col>
            <Col sm={isMobile ? 6 : 4}> 
              <TextField 
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  disabled={true}
                  label="Naturalidade"
                  value={this.state.naturalidade}
                  onChange={ (e) => this.setStateOnValueChange('naturalidade', e.target.value) }
                  name="naturalidade"/>
            </Col>
            <Col sm={isMobile ? 6 : 4}> 
              <TextField 
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  disabled={true}
                  label="Nacionalidade"
                  value={this.state.nacionalidadeNome}
                  onChange={ (e) => this.setStateOnValueChange('nacionalidadeNome', e.target.value) }
                  name="nacionalidadeNome"
                  inputProps={{ maxLength: 20 }}/>
            </Col>
        </Row>

        <SessionTitle>PESSOA POLITICAMENTE EXPOSTA</SessionTitle>
        <div style={{ border: '1px solid #ccc', borderRadius: '4px', padding: '16px', marginBottom: '16px' }}>
          <p style={{ fontWeight: 'bold', marginBottom: '8px' }}>
            TENDO EM VISTA QUE TIVE PLENA CIÊNCIA E ACESSO À LEGISLAÇÃO QUE INDICA OS CARGOS QUE IMPLICAM NA CONDIÇÃO DE PESSOA POLITICAMENTE EXPOSTA - PPE, BEM COMO AS INFORMAÇÕES ACIMA RELACIONADAS:
          </p>
          <p style={{ marginBottom: '16px' }}>
            Eu, <strong>{this.props.authData.usuario.nome}</strong>, DECLARO QUE (assinalar e/ou preencher uma das opções):
          </p>

          <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '12px' }}>
            <Radio
              checked={this.state.politicamenteExposta === 1}
              onChange={() => this.changePoliticamenteExposta(1)}
              disabled={this.state.disabled}
              style={{ flexShrink: 0, marginTop: '2px' }}
            />
            <span style={{ paddingTop: '9px' }}>
              NÃO ME ENQUADRO COMO PESSOA POLITICAMENTE EXPOSTA, pois não exerço e nunca exerci nenhum dos cargos ou funções acima mencionados e não tenho conhecimento que nenhum dos meus familiares ou pessoa do meu relacionamento próximo o tenha exercido.
            </span>
          </div>

          <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '12px' }}>
            <Radio
              checked={this.state.politicamenteExposta === 2}
              onChange={() => this.changePoliticamenteExposta(2)}
              disabled={this.state.disabled}
              style={{ flexShrink: 0, marginTop: '2px' }}
            />
            <div style={{ lineHeight: '3', paddingTop: '4px' }}>
              <span>SOU PESSOA POLITICAMENTE EXPOSTA, pois estou exercendo o cargo/função de </span>
              <span style={{ display: 'inline-block', width: isMobile ? '100%' : '180px', verticalAlign: 'middle' }}>
                <TextField
                  variant="outlined"
                  margin="dense"
                  fullWidth
                  disabled={this.state.disabled}
                  label="Cargo/Função"
                  InputLabelProps={{ shrink: true }}
                  value={this.state.cargoPpe}
                  onChange={(e) => this.setStateOnValueChange('cargoPpe', e.target.value)}
                  name="cargoPpe" />
              </span>
              <span> desde </span>
              <span style={{ display: 'inline-block', width: isMobile ? '45%' : '130px', verticalAlign: 'middle' }}>
                <DatePicker
                  variant="outlined"
                  margin="dense"
                  fullWidth
                  disabled={this.state.disabled}
                  label="dd/mm/aaaa"
                  InputLabelProps={{ shrink: true }}
                  value={this.state.dtDesdePpe}
                  onChange={(date) => this.setStateOnValueChange('dtDesdePpe', date)}
                  name="dtDesdePpe" />
              </span>
              <span> ou exerci no período de </span>
              <span style={{ display: 'inline-block', width: isMobile ? '45%' : '130px', verticalAlign: 'middle' }}>
                <DatePicker
                  variant="outlined"
                  margin="dense"
                  fullWidth
                  disabled={this.state.disabled}
                  label="dd/mm/aaaa"
                  InputLabelProps={{ shrink: true }}
                  value={this.state.dtInicioPpe}
                  onChange={(date) => this.setStateOnValueChange('dtInicioPpe', date)}
                  name="dtInicioPpe" />
              </span>
              <span> até </span>
              <span style={{ display: 'inline-block', width: isMobile ? '45%' : '130px', verticalAlign: 'middle' }}>
                <DatePicker
                  variant="outlined"
                  margin="dense"
                  fullWidth
                  disabled={this.state.disabled}
                  label="dd/mm/aaaa"
                  InputLabelProps={{ shrink: true }}
                  value={this.state.dtFimPpe}
                  onChange={(date) => this.setStateOnValueChange('dtFimPpe', date)}
                  onBlur={() => this.validateDateRange(this.state.dtInicioPpe, this.state.dtFimPpe, 'dtFimPpe')}
                  name="dtFimPpe" />
              </span>
              <span> (considerar os últimos 05 anos retroativamente à data de assinatura deste formulário).</span>
            </div>
          </div>

          <div style={{ display: 'flex', alignItems: 'flex-start' }}>
            <Radio
              checked={this.state.politicamenteExposta === 3}
              onChange={() => this.changePoliticamenteExposta(3)}
              disabled={this.state.disabled}
              style={{ flexShrink: 0, marginTop: '2px' }}
            />
            <div style={{ lineHeight: '3', paddingTop: '4px' }}>
              <span>SOU PESSOA POLITICAMENTE EXPOSTA em razão do meu </span>
              <span style={{ display: 'inline-block', width: isMobile ? '100%' : '200px', verticalAlign: 'middle' }}>
                <TextField
                  variant="outlined"
                  margin="dense"
                  fullWidth
                  disabled={this.state.disabled}
                  label="Grau"
                  value={this.state.idGrauRelacionamentoPpe}
                  onChange={(e) => this.setStateOnValueChange('idGrauRelacionamentoPpe', e.target.value)}
                  name="idGrauRelacionamentoPpe"
                  select={true}>
                  {this.state.tiposDependenciaPpe.map((td) => (
                    <MenuItem key={td.idTiposDependencia} value={td.idTiposDependencia}>
                      {td.descricao}
                    </MenuItem>
                  ))}
                </TextField>
              </span>
              <span> (indicar o membro da família/representante/pessoa de relacionamento próximo) exercer o cargo/função de </span>
              <span style={{ display: 'inline-block', width: isMobile ? '100%' : '180px', verticalAlign: 'middle' }}>
                <TextField
                  variant="outlined"
                  margin="dense"
                  fullWidth
                  disabled={this.state.disabled}
                  label="Cargo/Função"
                  InputLabelProps={{ shrink: true }}
                  value={this.state.tbxCargoFamiliarPpe}
                  onChange={(e) => this.setStateOnValueChange('tbxCargoFamiliarPpe', e.target.value)}
                  name="tbxCargoFamiliarPpe" />
              </span>
              <span> desde </span>
              <span style={{ display: 'inline-block', width: isMobile ? '45%' : '130px', verticalAlign: 'middle' }}>
                <DatePicker
                  variant="outlined"
                  margin="dense"
                  fullWidth
                  disabled={this.state.disabled}
                  label="dd/mm/aaaa"
                  InputLabelProps={{ shrink: true }}
                  value={this.state.dtDesdeFamiliarPpe}
                  onChange={(date) => this.setStateOnValueChange('dtDesdeFamiliarPpe', date)}
                  name="dtDesdeFamiliarPpe" />
              </span>
              <span> ou ter exercido no período de </span>
              <span style={{ display: 'inline-block', width: isMobile ? '45%' : '130px', verticalAlign: 'middle' }}>
                <DatePicker
                  variant="outlined"
                  margin="dense"
                  fullWidth
                  disabled={this.state.disabled}
                  label="dd/mm/aaaa"
                  InputLabelProps={{ shrink: true }}
                  value={this.state.dtFamiliarInicioPpe}
                  onChange={(date) => this.setStateOnValueChange('dtFamiliarInicioPpe', date)}
                  name="dtFamiliarInicioPpe" />
              </span>
              <span> até </span>
              <span style={{ display: 'inline-block', width: isMobile ? '45%' : '130px', verticalAlign: 'middle' }}>
                <DatePicker
                  variant="outlined"
                  margin="dense"
                  fullWidth
                  disabled={this.state.disabled}
                  label="dd/mm/aaaa"
                  InputLabelProps={{ shrink: true }}
                  value={this.state.dtFamiliarFimPpe}
                  onChange={(date) => this.setStateOnValueChange('dtFamiliarFimPpe', date)}
                  onBlur={() => this.validateDateRange(this.state.dtFamiliarInicioPpe, this.state.dtFamiliarFimPpe, 'dtFamiliarFimPpe')}
                  name="dtFamiliarFimPpe" />
              </span>
              <span> (considerar os últimos 05 anos retroativamente à data de assinatura deste formulário).</span>
            </div>
          </div>

        </div>

        <SessionTitle>DADOS DE CONTATO</SessionTitle>
        <Row>
            <Col sm={isMobile ? 6 : 4}>
              <InputCep 
                variant="outlined"
                margin="normal"
                fullWidth
                disabled={this.state.disabled}
                label="CEP"
                value={this.state.cepDadosContato}
                onChange={ this.changeCepDadosContatoValue }
                onFindAddress={this.preencherEnderecoDadosContato}
                onStartRequest={this.props.startLoadingAnimate}
                onStopRequest={this.props.stopLoadingAnimate}
                name="cepDadosContato"/>
            </Col>
            <Col sm={isMobile ? 6 : 4}>
              <TextField 
                variant="outlined"
                margin="normal"
                fullWidth
                disabled={this.state.disabled || (this.state.foundCepDadosContato && !!this.state.logradouroDadosContato)}
                label="Logradouro"
                value={this.state.logradouroDadosContato}
                onChange={ (e) => this.changeEnderecoDadosContato('logradouroDadosContato', e.target.value) }
                name="logradouroDadosContato"/>
            </Col>
            <Col sm={isMobile ? 6 : 4}>
              <TextField 
                variant="outlined"
                margin="normal"
                fullWidth
                disabled={this.state.disabled}
                label="Complemento"
                value={this.state.complementoDadosContato}
                onChange={ (e) => this.setStateOnValueChange('complementoDadosContato', e.target.value) }
                name="complementoDadosContato"/>
            </Col>
            <Col sm={isMobile ? 6 : 4}>
              <TextField 
                variant="outlined"
                margin="normal"
                fullWidth
                disabled={this.state.disabled || (this.state.foundCepDadosContato && !!this.state.bairroDadosContato)}
                label="Bairro"
                value={this.state.bairroDadosContato}
                onChange={ (e) => this.changeEnderecoDadosContato('bairroDadosContato', e.target.value) }
                name="bairroDadosContato"/>
            </Col>
            <Col sm={isMobile ? 6 : 4}>
              <TextField 
                variant="outlined"
                margin="normal"
                fullWidth
                disabled={this.state.disabled || (this.state.foundCepDadosContato && !!this.state.estadoDadosContato)}
                label="Estado"
                value={this.state.estadoDadosContato}
                onChange={ (e) => this.changeEstadoDadosContatoValue(e)}
                name="estadoDadosContato"
                select={true}>
                {this.state.estados.map(function(object, i){
                    return (<MenuItem value={object.estado}>{object.estado}</MenuItem>)
                })}
              </TextField>
            </Col>
            <Col sm={isMobile ? 6 : 4}>
                <Autocomplete
                  id="cidade-dados-contato-auto-complete"
                  options={this.state.cidadesDadosContato }
                  getOptionLabel={(option) => option?.municipio ?? ""}
                  autoComplete
                  includeInputInList
                  disableClearable
                  autoSelect
                  autoHighlight
                  openOnFocus
                  disabled={this.state.disabled || (this.state.foundCepDadosContato && !!this.state.cidadeDadosContato)}
                  fullWidth
                  onChange={(_, newValue) => this.changeCidadeDadosContatoValue(newValue)}
                  value={this.state.cidadeDadosContato}
                  onInputChange={(event, newValue) => this.changeAutocompleteValue(event, newValue, "cidadeDadosContato")} 
                  inputValue={this.state.cidadeDadosContato}
                  noOptionsText="Cidade não encontrada!"
                  renderInput={(params) => 
                  <TextField 
                    {...params}
                    variant="outlined"
                    margin="normal"
                    label="Cidade"
                    fullWidth
                    name="cidadeDadosContato"/>
                  } />
            </Col>
            <Col sm={isMobile ? 6 : 4}>
              <InputTelefone 
                variant="outlined"
                margin="normal"
                fullWidth
                disabled={this.state.disabled}
                label="Telefone"
                value={this.state.telefoneDadosContato}
                onChange={ (e) => this.setStateOnValueChange('telefoneDadosContato', e.target.value) }
                name="telefoneDadosContato"/>
            </Col>
            <Col sm={isMobile ? 6 : 4}>
              <InputTelefone 
                variant="outlined"
                margin="normal"
                fullWidth
                disabled={this.state.disabled}
                label="Telefone móvel"
                value={this.state.telefoneMovelDadosContato}
                onChange={ (e) => this.setStateOnValueChange('telefoneMovelDadosContato', e.target.value) }
                name="telefoneMovelDadosContato"/>
            </Col>
            <Col sm={isMobile ? 6 : 4}>
              <TextField 
                variant="outlined"
                margin="normal"
                fullWidth
                disabled={this.state.disabled}
                label="E-mail"
                value={this.state.emailDadosContato}
                onChange={ (e) => this.setStateOnValueChange('emailDadosContato', e.target.value) }
                name="emailDadosContato"/>
            </Col>
        </Row>
        

        <ButtonContainer>
          <Col sm={isMobile ? 6 : 4}>
            <FullSizedButton type="submit" className={`app-meus-dados-editar ${this.props.className}`} variant="contained"
              onClick={() => this.setState( { disabled : false } )}>
              <FontAwesome.FontAwesomeIcon icon={faEdit} className={`app-meus-dados-editar-icon ${this.props.className}`}/> 
              <span  className={`app-meus-dados-editar-label ${this.props.className}`}>EDITAR</span>
            </FullSizedButton>
          </Col>
          <Col sm={isMobile ? 6 : 4}>
            <FullSizedButton 
              type="submit" 
              className={`app-meus-dados-editar ${this.props.className}`} 
              variant="contained"
              disabled={this.state.disabled || !this.state.algumCampoEditado}
              onClick={this.handleSave}>
              <FontAwesome.FontAwesomeIcon icon={faSave} className={`app-meus-dados-editar-icon ${this.props.className}`}/> 
              <span  className={`app-meus-dados-editar-label ${this.props.className}`}>SALVAR</span>
            </FullSizedButton>
          </Col>
        </ButtonContainer>
      </div>
    )
  }
}


const mapStateToProps = store => ({
  authData: store.authState
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ startLoadingAnimate, stopLoadingAnimate, updateUserData }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps) (withRouter(withSnackbar(MeusDados)));